const UPDATE_FILTERS = 'UPDATE_FILTERS';
const RESET_FILTERS = 'RESET_FILTERS';

const initFiltersStore = (
  initState = () => ({}),
  otherGetters = {},
  otherActions = {},
  otherMutations = {}
) => {
  const state = () => ({
    filters: initState(),
  });
  const getters = {
    filters: state => state.filters,
    ...otherGetters,
  };
  const actions = {
    updateFilters({ commit }, filters) {
      commit(UPDATE_FILTERS, filters);
    },
    resetFilters({ commit }) {
      commit(RESET_FILTERS);
    },
    ...otherActions,
  };
  const mutations = {
    [UPDATE_FILTERS](state, filters) {
      state.filters = {
        ...state.filters,
        ...filters,
      };
    },
    [RESET_FILTERS](state) {
      state.filters = initState();
    },
    ...otherMutations,
  };

  return {
    state,
    getters,
    actions,
    mutations,
  };
};

export default initFiltersStore;
